// extracted by mini-css-extract-plugin
export default {"Title":"Results_Title__w3S8-"};